import React from 'react';

const SessionContext = React.createContext({
        username: "",
        token: "",
})

export default SessionContext;

